var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container" },
                [
                  _c(
                    "el-form",
                    {
                      attrs: {
                        inline: "",
                        size: "small",
                        "label-width": "120px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "商品名称",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.keyword,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "keyword", $$v)
                                },
                                expression: "listPram.keyword",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品品牌：" } },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "selWidth",
                              attrs: {
                                placeholder: "商品品牌",
                                size: "small",
                                clearable: "",
                              },
                              model: {
                                value: _vm.listPram.brand,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listPram, "brand", $$v)
                                },
                                expression: "listPram.brand",
                              },
                            },
                            [
                              _c("el-button", {
                                attrs: {
                                  slot: "append",
                                  icon: "el-icon-search",
                                  size: "small",
                                },
                                on: { click: _vm.handerSearch },
                                slot: "append",
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类：" } },
                        [
                          _c("el-cascader", {
                            staticClass: "selWidth ",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props,
                              clearable: "",
                              "show-all-levels": false,
                              size: "small",
                            },
                            on: { change: _vm.handerSearch },
                            model: {
                              value: _vm.listPram.categoryIds,
                              callback: function ($$v) {
                                _vm.$set(_vm.listPram, "categoryIds", $$v)
                              },
                              expression: "listPram.categoryIds",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex-btw" }, [
                    _c(
                      "div",
                      { staticClass: "buttons" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.exportSku },
                          },
                          [_vm._v("导出结果")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.importGoodsChange },
                          },
                          [_vm._v("导入修改")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "商品ID", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.imagePath
                          ? _c(
                              "div",
                              { staticClass: "demo-image__preview" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "36px",
                                    height: "36px",
                                  },
                                  attrs: {
                                    src: scope.row.imagePath,
                                    "preview-src-list": [scope.row.imagePath],
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "name", label: "商品名称", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "brandName", label: "品牌", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "category", label: "分类", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "原价", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "bidPrice", label: "成本价", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplyPrice",
                  label: "供货价",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          attrs: { controls: false, min: 0, size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.supplyPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "supplyPrice", $$v)
                            },
                            expression: "scope.row.supplyPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sellPrice", label: "售价", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input-number", {
                          attrs: { controls: false, min: 0, size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.changePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.sellPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "sellPrice", $$v)
                            },
                            expression: "scope.row.sellPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态", "min-width": "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "上架",
                            "inactive-text": "下架",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticStyle: { margin: "10px 0" } },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": _vm.constants.page.limit,
                  layout: _vm.constants.page.layout,
                  total: _vm.listData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.editDialogConfig.visible,
            title: "导入修改",
            top: "60px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.editDialogConfig, "visible", $event)
            },
          },
        },
        [
          _c(
            "el-alert",
            { attrs: { type: "warning", "show-icon": "", closable: false } },
            [
              _c("div", { attrs: { slot: "title" }, slot: "title" }, [
                _vm._v("\n\t\t\t\t\t温馨提示："),
                _c("br"),
                _vm._v("\n\t\t\t\t\t支持格式：xlsx、xls"),
                _c("br"),
                _vm._v(
                  "\n\t\t\t\t\t需要包含：产品ID、供货价、售价、启用状态。如无需修改请删除对应列。\n\t\t\t\t"
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex",
              staticStyle: {
                "margin-top": "20px",
                "align-items": "flex-start",
              },
            },
            [
              _c("div", [_vm._v("文件选择：")]),
              _vm._v(" "),
              _c("uploadFile", {
                attrs: { accept: ".xlsx, .xls" },
                model: {
                  value: _vm.editDialogConfig.url,
                  callback: function ($$v) {
                    _vm.$set(_vm.editDialogConfig, "url", $$v)
                  },
                  expression: "editDialogConfig.url",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editDialogConfig.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submitImport } },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }